export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.13-1828.25',
  commitId: 'ece3009c30f84c5202567e684a20483d185128aa',
  commitTime: '2026-02-13T18:28:25.000Z',
});
